export default function AboutSection() {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row gap-14 items-center">
          {/* Images */}
          <div className="flex gap-4 flex-shrink-0 w-full lg:w-auto">
            <div className="w-[40%] h-72 rounded-3xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/293bb7de92118913674869b9a667ea52.jpg"
                alt="Students studying"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="w-[60%] h-72 rounded-3xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=professional%20college%20counselor%20meeting%20with%20student%20in%20a%20bright%20modern%20office%20reviewing%20university%20applications%20warm%20academic%20setting%20clean%20background&width=360&height=360&seq=about2&orientation=landscape"
                alt="Counseling session"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Text */}
          <div className="flex-1">
            <span className="text-xs font-semibold tracking-widest uppercase text-amber-600 mb-3 block">
              About Crown SAT &amp; University
            </span>
            <h2
              className="text-3xl md:text-4xl font-bold text-gray-900 mb-5 leading-tight"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              We&apos;ve Helped 2,400+ Students Reach Their Dream Schools
            </h2>
            <p className="text-gray-500 text-sm leading-relaxed mb-5">
              Founded by Ivy League graduates and former admissions officers, Crown SAT &amp; University is the premier college prep platform for ambitious students across the USA and Europe. We combine elite academic expertise with personalized mentorship to give every student the competitive edge they need.
            </p>
            <p className="text-gray-500 text-sm leading-relaxed mb-8">
              Whether you&apos;re aiming for Harvard, MIT, Oxford, or any top-tier university, our proven system — covering SAT/ACT prep, essay coaching, and full admissions strategy — has delivered a <strong className="text-gray-800">98% acceptance rate</strong> to students&apos; top-choice schools.
            </p>

            <div className="grid grid-cols-2 gap-5 mb-8">
              {[
                { icon: "ri-medal-line", label: "Ivy League Founders", color: "text-amber-500" },
                { icon: "ri-global-line", label: "USA & Europe Students", color: "text-emerald-500" },
                { icon: "ri-shield-check-line", label: "Proven Track Record", color: "text-rose-500" },
                { icon: "ri-heart-line", label: "Student-First Approach", color: "text-violet-500" },
              ].map((item) => (
                <div key={item.label} className="flex items-center gap-3">
                  <div className={`w-9 h-9 flex items-center justify-center rounded-lg bg-gray-50`}>
                    <i className={`${item.icon} ${item.color} text-lg`}></i>
                  </div>
                  <span className="text-sm font-medium text-gray-700">{item.label}</span>
                </div>
              ))}
            </div>

            <a
              href="#booking"
              className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-gray-900 text-white text-sm font-semibold hover:bg-gray-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              Start Your Journey <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
